import { render, staticRenderFns } from "./singleFeedComponent.vue?vue&type=template&id=c61e2860&scoped=true"
import script from "./singleFeedComponent.vue?vue&type=script&lang=js"
export * from "./singleFeedComponent.vue?vue&type=script&lang=js"
import style0 from "./singleFeedComponent.vue?vue&type=style&index=0&id=c61e2860&prod&scoped=true&lang=css"
import style1 from "./singleFeedComponent.vue?vue&type=style&index=1&id=c61e2860&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61e2860",
  null
  
)

export default component.exports